import { Layout, LayoutProps } from "ra-ui-materialui";
import TopAppBar from "./TopAppBar";

const TopLayout = (props: LayoutProps): JSX.Element => (
  <Layout {...props} appBar={TopAppBar} />
);

export default TopLayout;
